// extracted by mini-css-extract-plugin
module.exports = {"marketplaceItem":"MarketplaceItem_marketplaceItem__2UBKd","reservedMarketplaceItem":"MarketplaceItem_reservedMarketplaceItem__6TgMl"};